import script from "./customDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./customDashboard.vue?vue&type=script&setup=true&lang=js"

import "./customDashboard.vue?vue&type=style&index=0&id=d26309c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d26309c2"]])

export default __exports__